import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LiveTicker from "./components/LiveTicker";
import HomePage from "./pages/HomePage";
import ChartPage from "./pages/ChartPage";
import AboutPage from "./pages/AboutPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/toaster";

function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#0b0f1a] text-slate-100 antialiased">
      <Header />
      <LiveTicker />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function Shell() {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    );
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/madhur-chart" element={<ChartPage kind="madhur" title="Madhur Chart" />} />
        <Route path="/starline-chart" element={<ChartPage kind="starline" title="Starline Chart" />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
    </PublicLayout>
  );
}

function App() {
  useEffect(() => {
    document.title = "Madhur Lottery | Result Today, Chart & Updates";
  }, []);

  return (
    <BrowserRouter>
      <Shell />
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
